type InputProps = {
  urlPath: string;
  pageTitle: string;
};

export const trackVirtualPageView = ({ urlPath, pageTitle }: InputProps) => {
  (window as any)._mtm = (window as any)._mtm || [];

  (window as any)._mtm.push({
    event: 'virtualPageView',
    modifiedUrl: `${window.location.origin}${urlPath}`,
    modifiedPageTitle: pageTitle,
  });
};
